<span class="error typography-footnote1">{{ errorText }}</span>
